import { NgModule } from "@angular/core";
import { Apollo, ApolloModule } from "apollo-angular";
import { ApolloLink, InMemoryCache } from "@apollo/client/core";

import { HttpClientModule, HttpErrorResponse } from "@angular/common/http";

import { environment } from "src/environments/environment";
import { getOperationAST } from "graphql";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { LoginService } from "./services/login/login.service";
import { take } from "rxjs/operators";

import { createClient } from "graphql-ws";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { HttpLink } from "apollo-angular/http";
import { onError } from "@apollo/client/link/error";

@NgModule({
  //TODO: exports: [HttpClientModule, ApolloModule, HttpLinkModule],
  exports: [HttpClientModule, ApolloModule],
})
export class GraphQLModule {
  constructor(
    apollo: Apollo,
    httpLink: HttpLink,
    private router: Router,
    private loginService: LoginService
  ) {
    const protocol = window.location.protocol;
    const host = window.location.host;
    const hostname = window.location.hostname;

    const uri = `${protocol}${environment.graphQlHost}`;
    const http = httpLink.create({ uri });

    let miUsuarioSubscription: Subscription = new Subscription();

    // websocket instantiation

    const wsbase = protocol.replace("http", "ws");

    const wsLink = new GraphQLWsLink(
      createClient({
        url: `${wsbase}/${host}${environment.graphql}`,
        lazyCloseTimeout: 10000,
        retryAttempts: 10,
      })
    );

    const errorLink = onError(({ networkError }) => {
      if (networkError) {
        const netError = networkError as HttpErrorResponse;
        if (netError.status === 401) {
          this.loginService
            .refreshToken()
            .pipe(take(1))
            .subscribe((res) => {
              miUsuarioSubscription.unsubscribe();
              if (Number(res["status"]) === 400) {
                this.router.navigate(["/login"]);
              } else {
                miUsuarioSubscription = this.loginService
                  .miUsuario()
                  .subscribe((user) => {
                    this.loginService.setMiUsuario(user);
                  });
              }
            });
        }
      }
    });

    // Creamos el split entre llamadas http y via websocket
    apollo.create({
      link: ApolloLink.split(
        (operation) => {
          const operationAST = getOperationAST(
            operation.query,
            operation.operationName
          );
          return !!operationAST && operationAST.operation === "subscription";
        },
        // ws,
        wsLink,
        // httpi
        errorLink.concat(http)
      ),
      cache: new InMemoryCache(),
    });
  }
}
